import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { setPortalVersionHeadOnRequest } from '@app/utils/http';
import { Observable } from 'rxjs';

@Injectable()
export class PortalVersionHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Logger.debug('PortalVersionHttpInterceptor', req, next)
    return next.handle(setPortalVersionHeadOnRequest(req));
  }
}
